// @ts-ignore
import { COURSE_SUBSCRIPTION_TIERS } from "@seneca/course-service-client";

export { COURSE_SUBSCRIPTION_TIERS };

export type SubscriptionTier =
  typeof COURSE_SUBSCRIPTION_TIERS[keyof typeof COURSE_SUBSCRIPTION_TIERS];
